import { render } from "./RecentPurchase.vue?vue&type=template&id=b3b9286c&scoped=true"
import script from "./RecentPurchase.vue?vue&type=script&lang=js"
export * from "./RecentPurchase.vue?vue&type=script&lang=js"

import "./RecentPurchase.vue?vue&type=style&index=0&id=b3b9286c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b9286c"]])

export default __exports__